import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import PayrollLiabilityService from '../../services/PayrollLiabilityReportService';
import {
    showToast,
    TOAST_TYPE,
    DKButton,
    showLoader,
    removeLoader,
  } from "deskera-ui-library";
const initialState = {
    data: {},
    columnConfig: [],
    status: 'idle',
    formData: {
        // liability: [],
        // assets: [],
        // paymentTerm: [],
        // sequenceFormats: []
    }
};
export const fetchPayrollLiabilityReport = createAsyncThunk('payrollLiabilityReport', async () => {
    showLoader()
    const response = await PayrollLiabilityService.getReport();
    removeLoader()
    return response;
});
export const PayrollLiabilityReportSlice = createSlice({
    name: 'payrollLiabilityReport',
    initialState,
    reducers: {
        addPayrollLiabilityColumnConfig: (state, action) => {
            const configs = action.payload;
            let configsToStore = [];
            configs.forEach((config) => {
                configsToStore.push({
                    ...config,
                    key: config.columnCode,
                    options: config.options ? config.options : []
                });
            });
            state.columnConfig = configsToStore;
        },
        addColumnToPayrollLiabilityColumnConfig: (state, action) => {
            state.columnConfig = [...state.columnConfig, action.payload];
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchPayrollLiabilityReport.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchPayrollLiabilityReport.fulfilled, (state, action) => {
                state.status = 'idle';
                state.data = action.payload;
            })
    }
});

export const { addPayrollLiabilityColumnConfig, addColumnToPayrollLiabilityColumnConfig } =
PayrollLiabilityReportSlice.actions;

export const selectPayrollLiability = (state) => {
    
    return state.payrollLiabilityReport? state.payrollLiabilityReport.data:{}
};

export const selectPayrollLiabilityColumnConfig = (state) =>
    state.payrollLiabilityReport.columnConfig;

export default PayrollLiabilityReportSlice.reducer;